import { componentsRestResource } from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { GetComponentsRequest } from "./get-components/GetComponentsRequest";
import { GetComponentsResponse } from "./get-components/GetComponentsResponse";
import { UpdateComponentsDeletionFlagsRequest } from "./update-components-deletion-flags/UpdateComponentsDeletionFlagsRequest";
import { UpdateComponentsDeletionFlagsResponse } from "./update-components-deletion-flags/UpdateComponentsDeletionFlagsResponse";

export const useGetComponents = () =>
  useRestResourceHook<GetComponentsRequest, GetComponentsResponse>((request) =>
    componentsRestResource.getComponents(request),
  );

export const useUpdateComponentsDeletionFlags = () =>
  useRestResourceHook<
    UpdateComponentsDeletionFlagsRequest,
    UpdateComponentsDeletionFlagsResponse
  >((request) => componentsRestResource.updateComponentsDeletionFlags(request));
